import { Button } from '@common/components';
import { cn } from '@core/utils';

export interface ContentsListFooterProps {
  className?: string;
  content?: React.ReactNode;
  niceJoinButton?: React.ReactNode;
  buttonTitle: string;
  disabled?: boolean;
  onClickContent?: () => void;
  loading?: boolean;
}

export const ContentsListFooter = ({
  className,
  content,
  niceJoinButton,
  buttonTitle,
  disabled = false,
  onClickContent,
  loading,
}: ContentsListFooterProps) => {
  return (
    <footer
      className={cn(
        'bg-white mt-60 flex flex-col gap-24 py-20 [&>button]:w-full [&>button]:py-24 [&>button]:text-[1rem] [&>button]:font-700',
        className,
      )}
    >
      {content ? (
        <div className="flex flex-col items-center gap-8 font-600 [&>h3]:m-0 [&>h3]:text-[1.25rem] [&>h3]:font-600 [&>h3]:text-Gray-900 [&>p]:m-0 [&>p]:text-[0.875rem] [&>p]:font-400 [&>p]:text-Gray-700">
          {content}
        </div>
      ) : null}
      <Button
        disabled={disabled}
        loading={loading}
        theme="primary-fill"
        onClick={onClickContent}
      >
        {buttonTitle}
      </Button>
      {niceJoinButton}
    </footer>
  );
};
